import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Actions } from '@packages/types';
import Image from 'next/image';
import getMobileOS from '../utils/getMobileOS';
export default function AppLinks({ trackingFunction }) {
    const mobileOS = getMobileOS();
    function trackAppStoreClick() {
        if (trackingFunction) {
            trackingFunction(Actions.ClickAppStore);
        }
    }
    function trackPlayStoreClick() {
        if (trackingFunction) {
            trackingFunction(Actions.ClickPlayStore);
        }
    }
    return (_jsxs("div", { className: "flex justify-around gap-4", children: [['iOS', 'unknown'].includes(mobileOS) ? (_jsx("a", { href: "https://apps.apple.com/no/app/dr-dropin/id1467608455?ls=1", className: "h-15 relative w-full md:w-1/2 md:max-w-[200px]", target: "_blank", rel: "noopener noreferrer", onClick: () => trackAppStoreClick(), children: _jsx(Image, { src: "/illustrations/appStoreiOS.png", alt: "Download on the App Store", fill: true, sizes: "100vw", style: {
                        objectFit: 'contain',
                    } }) })) : null, ['Android', 'unknown'].includes(mobileOS) ? (_jsx("a", { href: "https://play.google.com/store/apps/details?id=com.drdropin", target: "_blank", rel: "noopener noreferrer", className: "h-15 relative w-full md:w-1/2 md:max-w-[200px]", onClick: () => trackPlayStoreClick(), children: _jsx(Image, { src: "/illustrations/appStoreAndroid.png", alt: "Get it on Google Play", fill: true, sizes: "100vw", style: {
                        objectFit: 'contain',
                    } }) })) : null] }));
}
